module.exports = __webpack_public_path__ + "img/workspace.f52d7394.svg";